import { BELGE_VE_IMZALARI_LISTELE } from "../constants/requestUrls";
import { postRequest } from "../request";

const getFilesWithSigners = (props) => {
    let data = {};
    if (props !== undefined)
      data = JSON.stringify(props);
    return postRequest({ url: BELGE_VE_IMZALARI_LISTELE, data });
  }

export default getFilesWithSigners;